import { IApplicationState } from '../../../types/redux';

/**
 * Возвращает номер страницы списка при инициализации приложения
 */
export const selectInitialPageNumber = ({ settings: { initialPageNumber } }: IApplicationState) => initialPageNumber;
